import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Row, Col } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import { MDBDataTable } from "mdbreact";
import CustomGreenButton from "../../../components/shared/custom-green-button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import exportFromJSON from "export-from-json";
import swal from "sweetalert";
import { GENERAL_URL_API } from "../../../shared/urls";
import ExcelWorkBook from "../../../components/shared/ExcelWorkBook";
import { verInstitutos } from "../../../shared/fetchers/classics/banners/verInstitutos";
import { asignarBannerInstitutos, verAsignacionesBanner } from "../../../shared/fetchers/classics/banners/asignarBanner";
import { CloseRounded } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";
import { Tv } from "@material-ui/icons";

const AsignarBanner = ({ banner, onVolver, onBannerUpdate }) => {
  const classes = useStyles();

  // Estados para la tabla
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([
    { label: "Instituto", field: "instituto", sort: "asc", width: 300, isVisible: true },
  ]);

  // Estados para la asignación
  const [institutos, setInstitutos] = useState([]);
  const [institutosSeleccionados, setInstitutosSeleccionados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  useEffect(() => {
    if (banner) {
      obtenerInstitutos();
      obtenerAsignacionesActuales();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banner]);


  const obtenerInstitutos = async () => {
    try {
      const result = await verInstitutos();
      if (result.status) {
        // result.data es un array de strings: ["Instituto 1", "Instituto 2"]
        setInstitutos(result.data);
      } else {
        swal("Error", result.info || "No se pudieron cargar los institutos", "error");
      }
    } catch (error) {
      console.error("Error al obtener institutos:", error);
      swal("Error", "Error de conexión al obtener institutos", "error");
    }
  };

  const obtenerAsignacionesActuales = async () => {
    try {
      const result = await verAsignacionesBanner(banner.idBanners);
      
      if (result.status) {
        // result.data contiene objetos: [{idInstituteBanners, instituto, idBanners}, ...]
        // Extraer solo los nombres de institutos para la tabla
        const formattedRows = result.data?.map(item => ({
          instituto: item.instituto
        })) || [];
        setRows(formattedRows);
        
        // Preseleccionar institutos ya asignados (extraer solo los nombres)
        const institutosAsignados = result.data?.map(item => item.instituto) || [];
        setInstitutosSeleccionados(institutosAsignados);
        
        // Resetear selectAll si no todos los institutos están seleccionados
        if (institutosAsignados.length === institutos.length && institutos.length > 0) {
          setSelectAll(true);
        } else {
          setSelectAll(false);
        }
      } else {
        setRows([]);
        setInstitutosSeleccionados([]);
        setSelectAll(false);
      }
    } catch (error) {
      console.error("Error al obtener asignaciones:", error);
      setRows([]);
      setInstitutosSeleccionados([]);
      setSelectAll(false);
    }
  };



  const updateInstitutosSeleccionados = (list) => {
    // Eliminar duplicados (list es un array de strings)
    const uniqueList = [...new Set(list)];
    setInstitutosSeleccionados(uniqueList);
    
    // Actualizar estado del selectAll basado en la nueva selección
    if (uniqueList.length === institutos.length && institutos.length > 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const guardarAsignaciones = async () => {
    setLoading(true);
    try {
      // institutosSeleccionados ya es un array de strings
      const result = await asignarBannerInstitutos(banner.idBanners, institutosSeleccionados);
      
      if (result.status) {
        swal("Éxito", result.info || "Asignaciones guardadas correctamente", "success");
        obtenerAsignacionesActuales(); // Actualizar la tabla local
        
        // Actualizar la tabla principal de banners
        if (onBannerUpdate) {
          onBannerUpdate();
        }
      } else {
        swal("Error", result.info || "Error al guardar las asignaciones", "error");
      }
    } catch (error) {
      console.error("Error al guardar asignaciones:", error);
      swal("Error", "Error de conexión al guardar las asignaciones", "error");
    } finally {
      setLoading(false);
    }
  };

  const limpiarSeleccion = () => {
    setInstitutosSeleccionados([]);
    setSelectAll(false);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    
    if (newSelectAll) {
      // Seleccionar todos
      setInstitutosSeleccionados([...institutos]);
    } else {
      // Deseleccionar todos
      setInstitutosSeleccionados([]);
    }
    setSelectAll(newSelectAll);
  };

  const handleVolver = () => {
    // Actualizar la tabla principal antes de volver
    if (onBannerUpdate) {
      onBannerUpdate();
    }
    onVolver();
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={handleVolver}
          style={{ marginRight: "15px" }}
        >
          Volver
        </Button>
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">
          Asignar Banner: {banner?.titulo}
        </div>
      </div>
      
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <AssignmentIcon style={{ fontSize: "20px" }} />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                Asignar banner a institutos
              </div>
            </div>
            
            {/* Información del banner */}
            <div className="mt-3 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "5px" }}>
              <div className="row">
                <div className="col-md-6">
                  <strong>Banner:</strong> {banner?.titulo}
                </div>
                <div className="col-md-3">
                  <strong>Tipo:</strong> {banner?.tipoFormatted}
                </div>
                <div className="col-md-3">
                  <strong>Alcance:</strong> {banner?.alcance}
                </div>
              </div>
            </div>

            <form>
              <div className="d-flex justify-content-between flex-wrap">
                <label className="admin-label-text mt-3 d-block">
                  Seleccionar institutos:
                </label>
                <Button
                  disabled={!institutos.length}
                  variant="contained"
                  color="primary"
                  startIcon={
                    selectAll ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />
                  }
                  classes={
                    !selectAll
                      ? { root: classes.agregar }
                      : { root: classes.eliminar }
                  }
                  style={{
                    height: "1.5em",
                    alignSelf: "self-end",
                    marginBottom: "0.3em",
                  }}
                  onClick={handleSelectAll}
                >
                  {selectAll ? "Deseleccionar todos" : "Seleccionar todos"}
                </Button>
              </div>

              <Autocomplete
                multiple
                options={institutos}
                value={institutosSeleccionados}
                getOptionLabel={(option) => option || ""}
                disableCloseOnSelect
                noOptionsText="Sin resultados"
                onChange={(_, newValue) => updateInstitutosSeleccionados(newValue)}
                renderOption={(option, { selected }) => (
                  <>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={
                        selected ||
                        institutosSeleccionados.includes(option)
                      }
                      color="primary"
                    />
                    {option || ""}
                  </>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    style={{
                      width: "100%",
                      fontFamily: "'Noto Sans JP', sans-serif",
                    }}
                  />
                )}
              />

              <div className="mt-3">
                <Tooltip title="Guardar asignaciones">
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={loading}
                      startIcon={<CheckRoundedIcon />}
                      classes={{ root: classes.agregar }}
                      onClick={guardarAsignaciones}
                    >
                      {loading ? "Guardando..." : "Guardar Asignaciones"}
                    </Button>
                  </span>
                </Tooltip>
                
                <Tooltip title="Limpiar selección">
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={limpiarSeleccion}
                      className="ml-2"
                      startIcon={<CloseRounded style={{ fontSize: "25px" }} />}
                      disabled={loading}
                      style={{ background: "#5d9cec" }}
                    >
                      Limpiar
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </form>
          </Col>

          <Col xs={12} className="content-white-box px-4 py-4 mt-3">
            <div className="admin-main-title-dark-gray mb-3">
              <Tv /> Institutos asignados a este banner ({rows.length})
            </div>

            {rows.length === 0 && (
              <div className="alert alert-info mb-3" role="alert">
                <i className="fa fa-info-circle mr-2"></i>
                No hay institutos asignados a este banner actualmente.
              </div>
            )}

            {rows.length > 0 && (
              <ButtonGroup size="small" variant="contained" className="my-3">
                <CustomGreenButton
                  onClick={() => {
                    exportFromJSON({
                      data: rows,
                      fileName: `institutos-banner-${banner?.idBanners}`,
                      exportType: exportFromJSON.types.csv,
                    });
                  }}
                >
                  CSV
                </CustomGreenButton>
                <CustomGreenButton
                  onClick={() => {
                    exportFromJSON({
                      data: rows,
                      fileName: `institutos-banner-${banner?.idBanners}`,
                      exportType: exportFromJSON.types.json,
                    });
                  }}
                >
                  JSON
                </CustomGreenButton>
                <CustomGreenButton>
                  <ExcelWorkBook
                    columns={columns}
                    rows={rows}
                    filename={`institutos-banner-${banner?.idBanners}`}
                  />
                </CustomGreenButton>
              </ButtonGroup>
            )}
            
            {rows.length > 0 && (
              <MDBDataTable
                small
                responsive
                striped
                searchTop
                searchBottom={false}
                pagingTop
                bordered
                data={{
                  columns: columns,
                  rows: rows,
                }}
                noBottomColumns
                entriesOptions={[5, 10, 20, 50]}
                entriesLabel="Número de filas"
                searchLabel="Buscar"
                paginationLabel={["Anterior", "Siguiente"]}
                infoLabel={["Mostrando", "a", "de", "entradas"]}
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AsignarBanner;

const useStyles = makeStyles({
  agregar: {
    background: "#81c868",
    "&:hover": {
      backgroundColor: "#81c868",
    },
  },
  eliminar: {
    background: "#f05050",
    "&:hover": {
      backgroundColor: "#f05050",
    },
  },
}); 